<template>
  <div id="app">
    <a-locale-provider :locale="locale">
      <router-view />
    </a-locale-provider>
  </div>
</template>
<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
export default {
  data() {
    return {
      locale: zhCN,
    }
  },
  created() {
    var src = '//cdn.jsdelivr.net/npm/eruda'
    if (location.host.includes('test') || location.host.includes('local')) {
      document.write('<scr' + 'ipt src="' + src + '"></scr' + 'ipt>')
      document.write('<scr' + 'ipt>eruda.init();</scr' + 'ipt>')
    }
  },
}
</script>

<style lang="less">
@import './styles/index.less';
@import './styles/common.less';
</style>
